import { useEffect } from "react";
import { checkUserData } from "utils/AuthUtil";
import { initializeFCM } from "features/Firebase/utils/Firebase.utils";

export const FirebaseManager = () => {
  const has_user_data = checkUserData();
  useEffect(() => {
    // request for notification permission only if user is logged in
    if (has_user_data) {
      initializeFCM();
    }
  }, [has_user_data]);

  return null;
};
